import React, { useState, useEffect } from 'react'
import InfoModal from '../../components/InfoModal';

const ItemsTab = ({ specialItems, setSpecialItems, triggerAutoSave }) => {
    //アイテム
    const [cardName, setCardName] = useState("");
    const [cardScore, setCardScore] = useState(0);
    const [cardTime, setCardTime] = useState(0);
    const [cardDetail, setCardDetail] = useState("");
    const [focusCard, setFocusCard] = useState(null);
    const [waitingTime, setWaitingTime] = useState(0);

    //アイテムを追加
    const addCard = () => {
        const newCard = {
            name: cardName,
            score: Number(cardScore),
            time: Number(cardTime),
            detail: cardDetail,
            waitingTime: Number(waitingTime)
        }

        if(focusCard === null) {
            setSpecialItems((prev) => [
                ...prev,
                newCard
            ])
        } else {
            setSpecialItems((prev) => {
                const newCards = [...prev];
                newCards[focusCard] = newCard;
                return newCards;
            });
        }

        setCardName("");
        setCardScore(0);
        setCardTime(0);
        setCardDetail("");
        setFocusCard(null);
        setWaitingTime(0);

        triggerAutoSave();

        console.log(specialItems)
    }

    //アイテムを削除
    const deleteCard = (index) => {
        setFocusCard(null);
        setSpecialItems((prev) => {
            return prev.filter((card, i) => i !== index)
        })
        triggerAutoSave();
    }

    //アイテムを編集
    // specialItemsをここで依存に含めると、他の変更による更新のたびに編集中のフォームが上書きされてしまうため、
    // focusCardが変化した時のみ発火させる意図的な設計とする。
    useEffect(() => {
        if(focusCard !== null) {
            setCardName(specialItems[focusCard].name);
            setCardScore(specialItems[focusCard].score);
            setCardTime(specialItems[focusCard].time);
            setCardDetail(specialItems[focusCard].detail);
            setWaitingTime(specialItems[focusCard].waitingTime ? specialItems[focusCard].waitingTime : 0);
        } else {
            setCardName("");
            setCardScore(0);
            setCardTime(0);
            setCardDetail("");
            setWaitingTime(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [focusCard]);

    return (
        <div className='lg:grid lg:grid-cols-2'>
            <div className='mb-6 mx-3'>
                <h2 className='mb-3 text-center text-gray-600'>アイテム一覧</h2>
                {
                    specialItems && specialItems.map((card, index) => {
                        return (
                            <div key={index} className={'rounded-lg bg-white p-4 mb-3 relative cursor-pointer ' + (focusCard === index ? 'border border-purple-500 shadow' : 'shadow-sm')} onClick={() => setFocusCard(index)}>
                                <div className='text-lg tracking-widest mb-1'><i className='bi bi-card-checklist me-1 text-purple-500'></i>{card.name}</div>
                                <div className='text-sm text-gray-600'>消費スコア{card.score} pt</div>
                            </div>
                        )
                    })
                }

                <div className='rounded-lg bg-purple-500 px-4 py-3 mt-6 shadow-sm mb-3 relative cursor-pointer hover:bg-purple-600' onClick={() => setFocusCard(null)}>
                    <div className='text-lg tracking-widest text-white text-center'><i className='bi bi-plus-lg me-2'></i>アイテムを追加</div>
                </div>

            </div>

            <div className='mb-6 mx-3 bg-white border rounded-lg p-3 shadow-sm'>
                {/* アイテム情報の編集 */}
                <div className='mb-4 mx-2'>
                    <label>アイテム名</label>
                    <input value={cardName} onChange={(e) => setCardName(e.target.value)} type="text" className="w-full p-2 border rounded-lg mb-2 focus:outline-purple-300" />
                </div>

                <div className='mb-4 mx-2'>
                    <label>消費スコア</label>
                    <input value={cardScore} onChange={(e) => setCardScore(e.target.value)} type="number" placeholder='50' className="w-full p-2 border rounded-lg mb-2 focus:outline-purple-300" />
                </div>

                <div className='mb-4 grid grid-cols-2 gap-2 mx-2'>
                    <div>
                        <label>
                            有効時間 [分]
                            <InfoModal>
                                <p>「待ち時間」経過後、アイテムが有効な時間です。「待ち時間」が0分の場合、使用開始後すぐに有効化されます。</p>
                            </InfoModal>
                        </label>
                        <input value={cardTime} onChange={(e) => setCardTime(e.target.value)} type="number" placeholder='20' className="w-full p-2 border rounded-lg mb-2 focus:outline-purple-300" />
                    </div>

                    <div>
                        <label>
                            待ち時間 [分]
                            <InfoModal>
                                <p>アイテムを使用ボタンを押してから、実際に効果が有効になるまでの時間を設定します。</p>
                            </InfoModal>
                        </label>
                        <input value={waitingTime} onChange={(e) => setWaitingTime(e.target.value)} placeholder='0' type="number" className="w-full p-2 border rounded-lg mb-2 focus:outline-purple-300" />
                    </div>
                </div>

                <div className='mb-4 mx-2'>
                    <label>詳細</label>
                    <textarea value={cardDetail} onChange={(e) => setCardDetail(e.target.value)} className="w-full p-2 border rounded-lg mb-2 focus:outline-purple-300" rows="4"></textarea>
                </div>

                {/* 保存・削除ボタン */}
                <div className='grid grid-cols-3'>
                    <button type='button' className='mx-2 border-red-500 border text-red-600 p-2 rounded-lg hover:bg-red-100' onClick={() => deleteCard(focusCard)}><i className='bi bi-trash me-2'></i>削除</button>
                    <button type='button' className='mx-2 col-span-2 bg-purple-500 text-white p-2 rounded-lg hover:bg-purple-700' onClick={() => addCard()}><i className='bi bi-check-lg me-2'></i>保存</button>
                </div>
            </div>
        </div>
    )
}

export default ItemsTab
